import { CORE_SERVICE_URLS } from '~/Constants/Urls.constants';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { routeReplacer } from '~/Helpers/String.helper';
import { createRequestAction } from '~/Helpers/Action.helpers';
import { Provider } from '~/Models/DTO/Provider.model';

export const requestExternalParties = (provider: Provider) =>
  createRequestAction({
    name: REQUEST_ACTIONS.EXTERNAL_PARTIES,
    url: routeReplacer(CORE_SERVICE_URLS.EXTERNAL_PARTIES, { domain: provider.uuid }),
    method: 'GET',
  });
